<!-- Sidebar: desktop, or mobile web (not standalone) -->
<div *ngIf="!isMobile() || !isStandalone()">

	<!-- Overlay para mobile (legacy, hidden) -->
	<div *ngIf="(isCollapsed$ | async) === false" class="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
		(click)="toggleSidebar()">
	</div>

	<!-- Sidebar -->
	<div class="fixed top-0 h-screen z-[100] left-0" [class.left-4]="!isMobile()"
		[class.p-4]="!isMobile()">
		<aside [class]="getSidebarClasses()"
			class="flex flex-col h-full py-6 bg-accent-dark dark:bg-dark-secondary transition-[width,transform,opacity] duration-300 ease-in-out rounded-r-[40px]"
			[class.rounded-[40px]]="!isMobile()">

			<!-- Header del sidebar solo en mobile -->
			<div class="flex items-center justify-between px-4 mb-6 md:hidden">
				<h2 class="text-xl font-bold text-white ml-2">{{ TEXT.SIDEBAR.MENU_TITLE }}</h2>
				<button (click)="toggleSidebar()" class="text-gray-400 hover:text-white transition-colors">
					<span class="material-symbols-rounded text-[24px]">close</span>
				</button>
			</div>

			<div class="flex flex-col flex-1">
				<nav class="space-y-1 px-2">
					<div *ngFor="let item of (menuItems$ | async)" [routerLink]="item.route"
						routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}"
						[id]="'menu-item-' + item.route.replace('/', '') || 'dashboard'"
						class="flex items-center px-3 py-3 text-gray-400 rounded-2xl hover:text-white transition-colors duration-200 cursor-pointer relative group"
						[class.justify-center]="isCollapsedDesktop()" (click)="onMenuItemClick()">
						<div class="relative">
							<span class="material-symbols-rounded text-[24px]">{{ item.icon }}</span>
						</div>
						<span class="ml-3 transition-opacity duration-200" [class.hidden]="isCollapsedDesktop()"
							[class.opacity-100]="!isCollapsedDesktop() || isMobile()">
							{{ item.title }}
						</span>
						<span *ngIf="isCollapsedDesktop()"
							class="absolute left-14 bg-accent-dark dark:bg-dark-tertiary text-white dark:text-dark-text text-sm py-2 px-4 rounded-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all whitespace-nowrap z-[1000] pointer-events-none">
							{{ item.title }}
						</span>
					</div>
				</nav>

				<!-- Botón contextual "Nuevo" (solo desktop) -->
				<div class="px-3 mt-4" *ngIf="!isMobile()">
					<button (click)="onNewActionClick()"
						class="w-full flex items-center justify-center gap-1.5 py-2 px-3 bg-brand-primary text-gray-900 rounded-full text-sm font-medium shadow-soft hover:brightness-105 active:scale-95 transition-all duration-200"
						[class.!px-0]="isCollapsedDesktop()" [class.!py-2]="isCollapsedDesktop()">
						<span class="material-symbols-rounded text-[20px]">add</span>
						<span class="whitespace-nowrap" *ngIf="!isCollapsedDesktop() || isMobile()"
							[class.hidden]="isCollapsedDesktop()">
							{{ getFabLabel() }}
						</span>
					</button>
				</div>

				<!-- Área inferior unificada -->
				<div class="mt-auto px-2 mb-4">
					<nav class="space-y-1">
						<div *ngFor="let item of (bottomItems$ | async)" [routerLink]="item.route"
							routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"
							class="flex items-center px-3 py-3 text-gray-400 rounded-2xl hover:text-white transition-colors duration-200 cursor-pointer relative group"
							[class.justify-center]="isCollapsedDesktop()" (click)="onMenuItemClick()">
							<div class="relative">
								<span class="material-symbols-rounded text-[24px]">{{ item.icon }}</span>
							</div>
							<span class="ml-3 transition-opacity duration-200" [class.hidden]="isCollapsedDesktop()"
								[class.opacity-100]="!isCollapsedDesktop() || isMobile()">
								{{ item.title }}
							</span>
							<span *ngIf="isCollapsedDesktop()"
								class="absolute left-14 bg-accent-dark dark:bg-dark-tertiary text-white dark:text-dark-text text-sm py-2 px-4 rounded-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all whitespace-nowrap z-[100] pointer-events-none">
								{{ item.title }}
							</span>
						</div>
					</nav>

					<!-- Botón de colapsar -->
					<button (click)="toggleSidebar()"
						class="w-full mt-[6px] hidden md:flex items-center px-3 py-3 text-gray-400 rounded-2xl hover:text-white transition-colors duration-200"
						[class.justify-center]="isCollapsedDesktop()">
						<span class="material-symbols-rounded text-[24px]" [class.transform]="!isCollapsedDesktop()"
							[class.rotate-180]="!isCollapsedDesktop()">
							chevron_right
						</span>
						<span class="ml-3 transition-opacity duration-200" [class.hidden]="isCollapsedDesktop()"
							[class.opacity-100]="!isCollapsedDesktop()">
							{{ TEXT.SIDEBAR.COLLAPSE }}
						</span>
					</button>
				</div>
			</div>
		</aside>
	</div>
</div>